import type { CSSProperties } from "react";

import styles from "./Skeleton.module.scss";

type SkeletonVariant = "rounded" | "text" | "circular";

type Props = {
  variant?: SkeletonVariant;
  width?: CSSProperties["width"];
  height?: CSSProperties["height"];
  radius?: CSSProperties["borderRadius"];
  className?: string;
  style?: CSSProperties;
};

const VARIANT_CLASS: Record<SkeletonVariant, string> = {
  rounded: "",
  text: styles.text,
  circular: styles.circular,
};

const Skeleton = ({ variant = "rounded", width, height, radius, className = "", style }: Props) => (
  <span
    aria-hidden
    className={`${styles.skeleton} ${VARIANT_CLASS[variant]} ${className}`}
    style={{ width, height, borderRadius: radius, ...style }}
  />
);

export default Skeleton;
